<template>
  <div class="nx-searcher-filters">
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <nx-filters
        :filters="availableFilters"
        :disabledFilters="disabledFilters"
        :value="value"
        :label="$t('message.searcher.filters.filters')"
        v-on="$listeners"
        :scope="entity"
      ></nx-filters>
    </template>
    <template v-else>
      <v-expansion-panel>
        <v-expansion-panel-content class="nx-searcher-filters-toolbar">
          <template slot="header">
            <v-toolbar class="nx-heading--level-1 searcher-filters-title" color="transparent" flat>
              <v-toolbar-title>
                <v-layout>
                  <v-icon class="hidden-md-and-up" color="info">filter_list</v-icon>
                  <span class="nx-searcher-filters-title">{{ $t('message.searcher.filters.filters') }}</span>
                </v-layout>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <nx-filters
            :filters="availableFilters"
            :value="value"
            v-on="$listeners"
            :scope="entity"
          ></nx-filters>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </div>
</template>

<script>
import NxFilters from '@/components/filters/Filters';

export default {
  name: 'nx-searcher-filters',
  components: {
    NxFilters,
  },
  props: {
    entity: {
      type: String,
      required: true,
    },
    availableFilters: {
      type: Array,
      required: true,
    },
    disabledFilters: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="stylus">
@import '../../../assets/stylus/variables.styl'
.nx-searcher-filters {
  background-color: #e9e9f2;
  width: 100%
  height: auto;

  .v-toolbar__title {
    font-size: 18px;
  }

  .v-toolbar__content {
    height: 34px !important;
    margin-bottom: 4px;
  }

  $-toolbar {
    padding-top: 4px;
  }

  .v-toolbar__content, .v-toolbar__extension {
    height: 44px;
    margin-top: 8px;
    @media $sm-and-down {
      height: 40px !important;
      margin: 0;
      padding: 0;
    }
  }

  .searcher-filters-title + .v-expansion-panel__header__icon {
    .v-icon {
      color: $info !important;
    }
  }

  .v-expansion-panel {
    box-shadow: none;
  }

  .v-expansion-panel__header {
    padding: 6px 24px;
    min-height: 39px;
    @media $sm-and-down {
      padding: 0 20px;
    }
    @media $xs-only {
      padding: 0 10px;
    }
  }

  @media $sm-and-down {
    &-title {
      margin-left: 8px;
    }
  }
}
</style>
